"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = LoginPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var auth_layout_1 = require("../../components/auth/auth-layout");
var sign_in_form_1 = require("../../components/auth/sign-in-form");
var routes_1 = require("../../constants/routes");
var hooks_1 = require("../../store/hooks");
function LoginPage() {
    var accessToken = (0, hooks_1.useAppSelector)(function (state) { return state.user.token; });
    if (accessToken) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.VALIDATE_ACCOUNT, replace: true });
    }
    return ((0, jsx_runtime_1.jsx)(auth_layout_1.AuthLayout, { title: "Welcome Back.", subtitle: "Let's get started by filling out the form below.", children: (0, jsx_runtime_1.jsx)(sign_in_form_1.SignInForm, {}) }));
}
